// Dev/debug: optional local-only event log (not sent to Firestore). Prefer Firebase Auth + auditLogins for real visibility.
const ANALYTICS_KEY = "sparro_analytics_log";

function getAnalyticsLogs() {
  try {
    const logs = localStorage.getItem(ANALYTICS_KEY);
    return logs ? JSON.parse(logs) : [];
  } catch (error) {
    console.error("Error reading analytics logs:", error);
    return [];
  }
}

export const logUserLogin = (user, provider) => {
  const loginEvent = {
    timestamp: new Date().toISOString(),
    eventType: "login",
    userId: user.uid || "unknown",
    userEmail: user.email || "unknown",
    displayName: user.displayName || "Unknown User",
    provider,
    photoURL: user.photoURL || null,
  };

  const logs = getAnalyticsLogs();
  logs.push(loginEvent);
  try {
    localStorage.setItem(ANALYTICS_KEY, JSON.stringify(logs));
  } catch {
    // quota / private mode
  }
  return loginEvent;
};

export const logUserActivity = (activityType, details = {}) => {
  const activityEvent = {
    timestamp: new Date().toISOString(),
    eventType: activityType,
    details,
  };

  const logs = getAnalyticsLogs();
  logs.push(activityEvent);
  try {
    localStorage.setItem(ANALYTICS_KEY, JSON.stringify(logs));
  } catch {
    // ignore
  }
  return activityEvent;
};
